module.exports = __webpack_public_path__ + "img/gift-12.adf07682.jpg";